<template lang="pug">
content-preview-page(
  v-if='template',
  :content='template',
  :title='template.name',
  :description='template.description',
)
</template>

<script>
import ContentPreviewPage from '@apps/Dymal/ContentEditor/ContentPreview.vue'
import state, { getTemplateById } from './store/templates.store'

export default {
  name: 'TemplateContentEditor',

  components: { ContentPreviewPage },

  computed: {
    template: () => state.template,
  },

  async created () {
    if (!this.template) {
      await getTemplateById(this.$route.params.id_template)
    }
  },
}
</script>
